document.addEventListener("DOMContentLoaded", () => {
	document.addEventListener("wpcf7mailsent", () => {
			fbq('track', 'Lead');
	});
	document.querySelectorAll('a[href*="tel:"]').forEach((el) => {
		el.addEventListener('click', () => {
			fbq('track', 'Contact');
		});
	})
});
